/**
 * Theme Requirements Aggregation for Haven Realty Capital
 * 
 * Extends the base blue-haven theme requirements with Haven Realty Capital specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-blue-haven/requirements';

/**
 * Haven Realty Capital component requirement overrides.
 * Add requirements for any override components here.
 */
const havenrealtycapitalOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Haven Realty Capital theme.
 * Inherits from blue-haven theme and overrides with Haven Realty Capital components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...havenrealtycapitalOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
